<template>
  <section class="events-section" aria-label="Discover Alabama" v-if="events.length > 0">
    <div class="events-wrapper">
      <h2 class="full-span">Upcoming Events</h2>
      <div class="event-row" v-for="(event, index) in events" :key="index">
        <div v-if="event.eventDate" class="events-date">
          <router-link
            v-if="event.eventDate"
            :to="`/upcoming-events/${event.slug}`"
            class="events-link"
          >
            <div itemprop="startDate" v-if="event.eventStartDate === event.eventEndDate">
              {{ getDayOfWeek(convertToDate(event.eventStartDate)) }}
              <p>{{ getFormattedDate(convertToDate(event.eventStartDate)) }} {{ event.time }}</p>
            </div>
            <div itemprop="startDate" v-else>
              {{ getDayOfWeek(convertToDate(event.eventStartDate)) }} -
              {{ getDayOfWeek(convertToDate(event.eventEndDate)) }}
              <p>
                {{ getFormattedDate(convertToDate(event.eventStartDate))
                }}<span style="font-size: 0.75rem"> to</span> <br />
                {{ getFormattedDate(convertToDate(event.eventEndDate)) }}
                {{ event.time }}
              </p>
            </div>
          </router-link>
        </div>
        <div class="events-info">
          <p>
            <img
              src="/images/events/map-north.svg"
              class="region-map"
              alt=""
              role="presentation"
              v-if="event.region == 'north-alabama'"
            />
            <img
              src="/images/events/map-central.svg"
              class="region-map"
              alt=""
              role="presentation"
              v-if="event.region == 'central-alabama'"
            />
            <img
              src="/images/events/map-south.svg"
              class="region-map"
              alt=""
              role="presentation"
              v-if="event.region == 'south-alabama'"
            />
            <img
              src="/images/events/map-beach.svg"
              class="region-map"
              alt=""
              role="presentation"
              v-if="event.region == 'beaches-gulf-coast'"
            />

            <span class="region"> {{ event.area }} &raquo; </span
            ><span class="city">{{ event.city }}</span>
          </p>
          <router-link v-if="event.eventDate" :to="`/upcoming-events/${event.slug}`">
            <p class="title">{{ event.title }}</p>
          </router-link>
        </div>
      </div>
      <div class="full-span">
        <router-link class="view-all-button" to="/festivals-and-events"
          >View All Events in {{ cityName }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
// import UserFavorite from '@/components/Common/UserFavorite.vue';
import { convertToDate, getFormattedDate, getDayOfWeek } from '../../../store/helpers/helpers';

export default {
  props: {
    defaultSearch: {
      type: String,
    },
    citySlug: {
      type: String,
    },
    area: {
      type: String,
    },
    experienceId: {
      type: [Number, String],
    },
    cityId: {
      type: Number,
    },
    cityName: {
      type: String,
    },
    events: {
      type: [Array],
    },
  },

  methods: {
    convertToDate,
    getFormattedDate,
    getDayOfWeek,
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #173945;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }

  &:visited {
    color: #173945;
  }
}

a.button {
  color: #ffffff;
}

.events-wrapper {
  width: min(90vw, 650px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.full-span {
  grid-column: span 3 / span 3;
}
.events-date {
  display: grid;
  grid-column: span 1 / span 3;
  font-weight: lighter;
  font-size: 1rem;
  text-align: left;
  height: min-content;
  @media screen and (max-width: 998px) {
    font-size: 0.8rem;
    grid-column: 1 / span 1;
    display: flex;
    justify-content: flex-end;
  }
}
.event-row {
  grid-column: span 3 / span 3;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
  @media screen and (max-width: 998px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    grid-column: span 3 / span 3;
  }
}
.events-link {
  background-color: #d1d7da;
  border-radius: var(--spacing-xxs);
  padding: 0.5rem 1rem 0.5rem 1rem;
  color: #173945;
  width: 100%;
  @media screen and (max-width: 998px) {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
}
.events-date p {
  font-weight: 800;
  font-size: 1.5rem;
  margin-bottom: 0;

  @media screen and (max-width: 998px) {
    font-size: 0.75rem;
  }
}
.events-info {
  grid-column: span 2 / span 2;
  @media screen and (max-width: 998px) {
    grid-column: 2 / span 2;
  }
}

.events-info p {
  text-align: left;
  margin-bottom: 0;
}

.region {
  font-size: 1rem;
  @media screen and (max-width: 998px) {
    font-size: 0.6rem;
  }
}
.city {
  font-size: 1rem;
  font-weight: 800;
  @media screen and (max-width: 998px) {
    font-size: 0.6rem;
  }
}
.title {
  font-size: 1.5rem;
  font-family: 'klinicslabbold';
  @media screen and (max-width: 998px) {
    font-size: 1.2rem;
  }
}

.event-location {
  display: inline;
}
.region-map {
  width: 10px;
  @media screen and (max-width: 998px) {
    width: 7px;
  }
}

.view-all-button {
  font-family: 'klinicslabbold';
  &:hover {
    text-decoration: underline;
  }
}
</style>
